import DashboardIcon from "@mui/icons-material/Dashboard";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PeopleIcon from "@mui/icons-material/People";
// import ExpandLess from "@mui/icons-material/ExpandLess";
// import ExpandMore from "@mui/icons-material/ExpandMore";

export const filterIcons = (inconName = "dashboard", details) => {
  switch (inconName) {
    case "dashboard":
      return <IconDashBoard details={details} />;
    case "ad":
      return <IconAssignmentIcon details={details} />;
    case "advertiser":
      return <IconPeopleIcon details={details} />;
    default:
      break;
  }
};

const IconDashBoard = ({ details }) => {
  return (
    <DashboardIcon color={details.color} sx={{ fontSize: details.fontSize }} />
  );
};

const IconAssignmentIcon = ({ details }) => {
  return (
    <AssignmentIcon color={details.color} sx={{ fontSize: details.fontSize }} />
  );
};

const IconPeopleIcon = ({ details }) => {
  return (
    <PeopleIcon color={details.color} sx={{ fontSize: details.fontSize }} />
  );
};
